<template>
  <v-container :class="containerClass" fluid>
    <lesson-plan-form
      mode="view"
      :lesson-plan="lessonPlan.data"
      @cancel="onCancel"
    >
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('lesson-plans.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>View {{ lessonPlan.data.name }}</h2>
        </div>
      </template>
    </lesson-plan-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import LessonPlanForm from '@components/LessonPlan/Form'
export default {
  components: {
    LessonPlanForm,
  },
  layout: LayoutDashboard,
  props: {
    lessonPlan: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onCancel() {
      window.location.href = this.$route('lesson-plans.index')
    },
  },
}
</script>
